import { httpClient } from '@ahm/api-wrappers-core';

import { apiRoutes } from '@/api/api-routes';

export interface TruckPackageDetail {
  height: number;
  length: number;
  quantity: number;
  weight: number;
  width: number;
}

export interface BillableWeightRequestBody {
  package_detail: TruckPackageDetail[];
  package_dimension_unit: string;
  service_id: string;
}

export interface TruckPackageWeightDetail {
  billable_weight: number;
  volumetric_weight: number;
}

export interface BillableWeightResponse {
  weight: number;
  length: number;
  width: number;
  height: number;
  billable_weight: number;
  total_volumetric_weight: number;
  total_billable_weight: number;
  dim_factor: number;
  package_weight_details: TruckPackageWeightDetail[];
}

export const billableWeightFn = async (body: BillableWeightRequestBody) => {
  const response = await httpClient.post<BillableWeightResponse>(
    apiRoutes.billableWeight,
    body
  );

  return response.data;
};
